<template>
    <div>
        <div class="container">
            <div class="row my-5">
                <div class="col-12 col-md-10 offset-md-1 text-center my-5">
                    <h1 class="heading">Metropolis Asia</h1>
                    <hr class="custom-hr">
                    <p class="about-text mt-5">The city gives hard knocks to everyone. In the fast paced urban space we seek for an existence, a continuous trial to fit in. The "METROPOLIS" teaches all of us to thrive on, to Dream on and most importantly to live on! Metropolis the urban winter festival is an annual event.It promotes and presents the best possible coalition of every artistic experience to as many people as possible hosted by a city which embraces everybody…Guwahati</p>
                    <p class="about-text">Began at 2012, the festival brings together our diverse community, increases cultural awareness, simultaneously bringing an unparalleled feast of dance, theatre, music, visual arts, workshops, multimedia and outdoor events from renowned and upcoming artists from whole northeast, mainland India and world. Metropolis Festival is a key destination festival across the entire Northeast. Every Year it brings an unparalleled feast of dance, theatre, music, visual arts, workshops, multi-media and outdoor events from renowned and upcoming artists from whole Northeast, mainland India and World. </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

